<h3 class="title">
  {{ title }}
</h3>

<div class="info-card-content">
  @if (activeDevices) {
    <p class="count" [innerHTML]="activeDevices">
    </p>
  }

  @if (count) {
    <p class="count">
      {{ count }}
    </p>
  }

  @if (indicator) {
    <span
      class="status-indicator"
      [class.green]="indicator === 'green'"
      [class.red]="indicator === 'red'"
      [class.yellow]="indicator === 'yellow'">
    </span>
  } @else {
    <app-button-icon [iconName]="icon"
                     (click)="iconClick()"
                     [routerLink]="routerLink" />
  }
</div>

@if (text && !activeAlarmText) {
  <p class="change-text" [innerHTML]="text">

  </p>
} @else if (activeAlarmText && !text) {
  <p class="active-alarm">
    <a class="dark-red"
       routerLink="/alarms"
       [queryParams]="{severity:'critical'}">
      {{ activeAlarmText.critical }} {{'common.enum.alarm-severity.critical' | translateSafe}}
    </a>

    <a class="red"
       routerLink="/alarms"
       [queryParams]="{severity:'high'}">
      {{ activeAlarmText.high }} {{'common.enum.alarm-severity.high' | translateSafe}}
    </a>

    <a class="yellow"
       routerLink="/alarms"
       [queryParams]="{severity:'warning'}">
      {{ activeAlarmText.warning }} {{'common.enum.alarm-severity.warning' | translateSafe}}
    </a>

    <a class="blue"
       routerLink="/alarms"
       [queryParams]="{severity:'info'}">
      {{ activeAlarmText.info }} {{'common.enum.alarm-severity.info' | translateSafe}}
    </a>
  </p>
}
